import appsettingsFile from '../appsettings.json';
import { IAppSettings, IAppSettingsEnviroment } from './appsettings/model';
import * as Actions from './redux/actions';
import { IDataStorage } from './redux/reducers';
import Translate from './translate';

const appsettings = appsettingsFile as IAppSettings;

const Settings = () : IAppSettingsEnviroment => 
  (appsettings as any)[window.app_enviroment ?? 'production'] as IAppSettingsEnviroment;

const ServerFileUrl = (id?: number) => {
  let url = Settings().api.url;
  if (!url.endsWith('/')) url += '/';
  return `${url}file/${id}`;
}

export { appsettings, Settings, ServerFileUrl, Actions, Translate };
export type { IDataStorage };
